import React, { type FC } from 'react'
import { Flex } from 'antd'
import {
  SubtractCircle20Regular,
  CopyArrowRight20Regular,
  Edit20Regular
} from '@fluentui/react-icons'

import { type IUserPermission } from '../../../constants/types/common'
import { ButtonWithTooltip } from '../../../components/shared'
import { COPY_PERMISSIONS, EDIT_PERMISSIONS, REMOVE_PERMISSIONS } from '../../../components/shared/constants'
import { RemovePermissionsPopover } from './RemovePermissionsPopover'

interface IPermissionTableActions {
  selectedUserId: string
  permission: IUserPermission
  copyPermission: (permission: IUserPermission) => void
  editPermission: (permission: IUserPermission) => void
}

export const PermissionTableActions: FC<IPermissionTableActions> = ({
  selectedUserId,
  permission,
  copyPermission,
  editPermission
}) => (
  <Flex justify='center' gap={6}>
    <RemovePermissionsPopover
      selectedUserId={selectedUserId}
      selectedRelationships={[permission]}
      children={(
        <ButtonWithTooltip
          tooltipText={REMOVE_PERMISSIONS}
          type='text'
          data-testid={`remove-permission-button-${permission.resourceId}`}
          icon={<SubtractCircle20Regular />}
        />
      )}
    />
    <ButtonWithTooltip
      tooltipText={COPY_PERMISSIONS}
      type='text'
      onClick={() => copyPermission(permission)}
      data-testid={`copy-permission-button-${permission.resourceId}`}
      icon={<CopyArrowRight20Regular />}
    />
    <ButtonWithTooltip
      tooltipText={EDIT_PERMISSIONS}
      type='text'
      onClick={() => editPermission(permission)}
      data-testid={`edit-permission-button-${permission.resourceId}`}
      icon={<Edit20Regular />}
    />
  </Flex>
)
